/* Storied Rugs — theme behaviour */

/* ============ Overlays (cart, search, menu, filters) ============ */
var _ovlLastFocus = null;

function _focusables(root){
  return Array.prototype.filter.call(
    root.querySelectorAll('a[href],button:not([disabled]),input:not([type=hidden]),select,textarea,[tabindex]:not([tabindex="-1"])'),
    function(el){ return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement; }
  );
}

var _OVL_ADLARI = { menu: 'Menu', search: 'Search', filter: 'Filters', cart: 'Cart' };

function _ovlAcikPanel(){
  var el = document.querySelector('.ovl.open');
  if(!el) return null;
  return el.querySelector('.drawer, .search-panel') || el;
}

/* SR-A11Y-2026-09-08: keep Tab inside an open overlay. Measured before the fix: focusing the last
   control and pressing Tab moved focus onto the page behind the drawer. */
function _ovlOdakTuzagi(e){
  if(e.key !== 'Tab') return;
  var panel = _ovlAcikPanel();
  if(!panel) return;
  var f = _focusables(panel);
  if(!f.length) return;
  var ilk = f[0], son = f[f.length - 1];
  if(e.shiftKey && (document.activeElement === ilk || !panel.contains(document.activeElement))){
    e.preventDefault(); son.focus();
  } else if(!e.shiftKey && document.activeElement === son){
    e.preventDefault(); ilk.focus();
  } else if(!panel.contains(document.activeElement)){
    e.preventDefault(); ilk.focus();
  }
}
document.addEventListener('keydown', _ovlOdakTuzagi, true);

function openOvl(k){
  var el = document.getElementById('ovl-' + k);
  if(!el) return;
  _ovlLastFocus = document.activeElement;
  el.classList.add('open');
  el.setAttribute('aria-hidden','false');
  /* SR-A11Y-2026-09-08: expose the overlay as a modal dialog. Before this the containers were plain
     divs, so assistive technology never announced that a dialog had opened. */
  el.setAttribute('role','dialog');
  el.setAttribute('aria-modal','true');
  if(!el.getAttribute('aria-label')) el.setAttribute('aria-label', _OVL_ADLARI[k] || 'Dialog');
  document.body.style.overflow = 'hidden';
  var panel = el.querySelector('.drawer, .search-panel') || el;
  /* SR-A11Y-2026-09-08: the panel transition is 300-350 ms, so a single 250 ms timeout raced it and
     focus() on a still-hidden element silently did nothing. Try, then verify and retry. */
  var odakla = function(){
    if(k === 'search'){
      var i = document.getElementById('searchInput');
      if(i){ i.focus(); return panel.contains(document.activeElement); }
    }
    var f = _focusables(panel);
    if(f.length) f[0].focus();
    return panel.contains(document.activeElement);
  };
  setTimeout(function(){
    if(odakla()) return;
    setTimeout(odakla, 250);
  }, 250);
}

function closeOvl(){
  var closed = false;
  document.querySelectorAll('.ovl.open').forEach(function(e){
    e.classList.remove('open');
    e.setAttribute('aria-hidden','true');
    e.removeAttribute('aria-modal');
    closed = true;
  });
  document.body.style.overflow = '';
  if(closed && _ovlLastFocus && typeof _ovlLastFocus.focus === 'function'){
    _ovlLastFocus.focus();
    _ovlLastFocus = null;
  }
}

document.addEventListener('keydown', function(e){
  if(e.key === 'Escape'){ closeOvl(); return; }
  if(e.key !== 'Tab') return;
  var open = document.querySelector('.ovl.open');
  if(!open) return;
  var panel = open.querySelector('.drawer, .search-panel') || open;
  var f = _focusables(panel);
  if(!f.length) return;
  var first = f[0], last = f[f.length - 1];
  if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
  else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
});

// menu drawer slides from the left rather than the right
(function(){
  var menuOvl = document.getElementById('ovl-menu');
  var mdr = menuOvl && menuOvl.querySelector('.drawer');
  if(!menuOvl || !mdr) return;
  new MutationObserver(function(){
    mdr.style.transform = menuOvl.classList.contains('open') ? 'translateX(0)' : 'translateX(-100%)';
  }).observe(menuOvl, { attributes: true, attributeFilter: ['class'] });
})();

// header shadow on scroll
(function(){
  var hdr = document.getElementById('hdr');
  if(!hdr) return;
  window.addEventListener('scroll', function(){
    hdr.classList.toggle('scrolled', window.scrollY > 12);
  }, { passive: true });
})();

/* ============ Sliders ============ */
function slide(btn, dir){
  var sec = btn.closest('section');
  var s = sec && sec.querySelector('.slider');
  if(!s) return;
  var firstChild = s.querySelector('*');
  var amt = firstChild ? firstChild.offsetWidth + 22 : 300;
  s.scrollBy({ left: dir * amt * 1.2, behavior: 'smooth' });
}

function slidePage(btn, dir){
  var sec = btn.closest('section');
  var s = sec && sec.querySelector('.slider');
  if(!s) return;
  s.scrollBy({ left: dir * Math.round(s.clientWidth * 0.86), behavior: 'smooth' });
}

document.querySelectorAll('.slider').forEach(function(s){
  var sec = s.closest('section');
  var c = sec && sec.querySelector('.slider-count');
  if(!c) return;
  function up(){
    var pages = Math.max(1, Math.ceil((s.scrollWidth - 4) / s.clientWidth));
    var cur = Math.min(pages, Math.floor(s.scrollLeft / s.clientWidth) + 1);
    c.textContent = cur + ' / ' + pages;
  }
  s.addEventListener('scroll', function(){ requestAnimationFrame(up); }, { passive: true });
  window.addEventListener('resize', up);
  setTimeout(up, 350);
});

/* ============ Client-side category pills ============ */
function filterGrid(btn, cat){
  var wrap = btn.closest('section');
  if(!wrap) return;
  wrap.querySelectorAll('.pill').forEach(function(p){ p.classList.remove('on'); });
  btn.classList.add('on');
  var n = 0;
  wrap.querySelectorAll('[data-cat]').forEach(function(c){
    var tokens = c.getAttribute('data-cat') || '';
    var show = (cat === 'all' || tokens.indexOf(cat) > -1);
    c.style.display = show ? '' : 'none';
    if(show) n++;
  });
  var cnt = wrap.querySelector('[data-count]');
  if(cnt) cnt.textContent = n;
}

/* ============ Saved rugs (wishlist), persisted locally ============ */
var Saved = (function(){
  var KEY = 'storied:saved';
  function read(){
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch(e){ return []; }
  }
  function write(list){
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch(e){}
  }
  return {
    all: read,
    has: function(h){ return read().indexOf(h) > -1; },
    toggle: function(h){
      var list = read();
      var i = list.indexOf(h);
      if(i > -1) list.splice(i, 1); else list.push(h);
      write(list);
      return i === -1;
    }
  };
})();

// Update the saved-count badge(s) in the header
function renderSavedCount(){
  var n = Saved.all().length;
  document.querySelectorAll('[data-saved-count]').forEach(function(b){
    b.textContent = n;
    b.hidden = n === 0;
  });
}

function favToggle(e, el){
  e.preventDefault();
  e.stopPropagation();
  var handle = el.getAttribute('data-save');
  if(handle){
    var on = Saved.toggle(handle);
    // SR-SAVE-EVENT-2026-10-09: anonymous save count per rug, sent to the analytics already on the page
    try {
      if (window.gtag) window.gtag('event', on ? 'add_to_wishlist' : 'remove_from_wishlist', { item_id: handle, items: [{ item_id: handle }] });
      if (window.clarity) window.clarity('event', on ? 'save_rug' : 'unsave_rug');
    } catch (err) {}
    el.classList.toggle('on', on);
    el.setAttribute('aria-pressed', on ? 'true' : 'false');
    // keep every control for the same product in sync on this page
    document.querySelectorAll('[data-save="' + handle + '"]').forEach(function(other){
      if(other === el) return;
      other.classList.toggle('on', on);
      other.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  } else {
    el.classList.toggle('on');
  }
  renderSavedCount();
  return false;
}

// restore saved state on load
document.querySelectorAll('[data-save]').forEach(function(el){
  var on = Saved.has(el.getAttribute('data-save'));
  el.classList.toggle('on', on);
  el.setAttribute('aria-pressed', on ? 'true' : 'false');
});
renderSavedCount();

/* ============ Accordions: open one, close the rest ============ */
document.querySelectorAll('.acc').forEach(function(acc){
  acc.querySelectorAll('details').forEach(function(d){
    d.addEventListener('toggle', function(){
      if(d.open){
        acc.querySelectorAll('details').forEach(function(o){ if(o !== d) o.open = false; });
      }
    });
  });
});

/* ============ Reveal on scroll ============ */
(function(){
  if(!document.body.classList.contains('anim-on')) return;
  var SELECTORS = '.sec-head, .trust .it, .craft-points, .nl-inner, .story-copy, .ab-band';
  var targets = Array.prototype.slice.call(document.querySelectorAll(SELECTORS));
  if(!targets.length) return;

  if(!('IntersectionObserver' in window)) return; // no JS reveal = content simply stays visible
  targets.forEach(function(e){ e.classList.add('reveal'); });

  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); }
    });
  }, { threshold: .08, rootMargin: '0px 0px -8% 0px' });
  targets.forEach(function(e){ io.observe(e); });

  // safety net: never leave content invisible
  setTimeout(function(){
    document.querySelectorAll('.reveal:not(.in)').forEach(function(e){
      if(e.getBoundingClientRect().top < window.innerHeight * 1.2) e.classList.add('in');
    });
  }, 2400);
})();

/* ============ Shared helpers ============ */
// Exported so sections rendered from Liquid can reuse them. Keeping the money
// format here (a .js asset) avoids Liquid trying to evaluate its {{amount}} tags.
window.escapeHtml = function(s){
  return String(s == null ? '' : s)
    .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
    .replace(/"/g,'&quot;').replace(/'/g,'&#39;');
};


window.moneyKuru = (function(){
  var o = String(window.moneyOrnek || '');
  var ilk = o.search(/\d/);
  if (ilk < 0) return null;
  var ters = o.split('').reverse().join('');
  var son = o.length - ters.search(/\d/);
  var govde = o.slice(ilk, son);
  var m = govde.match(/^(.*)([^\d])(\d{2})$/);   /* son ayirici + iki ondalik */
  if (!m) return null;
  var ondalik = m[2];
  var binlik = (m[1].replace(/\d/g, '')[0]) || '';
  if (binlik && binlik === ondalik) return null;  /* ayirt edilemiyor */
  return { onEk: o.slice(0, ilk), sonEk: o.slice(son), binlik: binlik, ondalik: ondalik };
})();

window.formatMoney = function(cents, secenek){
  var k = window.moneyKuru;
  if (k) {
    var eksi = cents < 0, p = (Math.abs(cents) / 100).toFixed(2).split('.');
    var tam = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, k.binlik);
    var sondakiSifirlar = !(secenek && secenek.sondakiSifirlar === false);
    var govde = (!sondakiSifirlar && p[1] === '00') ? tam : tam + k.ondalik + p[1];
    return (eksi ? '-' : '') + k.onEk + govde + k.sonEk;
  }
  /* fallback path: the shop's own format string. It is not market aware and only kicks
     in when the rule cannot be derived from the sample. */
  try {
    return (window.moneyFormat || '${{amount}}')
      .replace(/\{\{\s*amount\s*\}\}/, (cents/100).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2}))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents/100).toLocaleString('en-US'))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, (cents/100).toFixed(2).replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, String(Math.round(cents/100)));
  } catch(e){ return '$' + (cents/100).toFixed(2); }
};

// Shopify CDN URLs already carry a ?v= query, so width must be appended.
window.imageWidth = function(url, w){
  if(!url) return '';
  return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
};

/* ============ Shopify cart integration ============ */
(function(){

  /* The error is printed into the same container on both the cart page and the product
   page. (2026-08-16 session L: the removed cart drawer's error container used to be
   looked up as a second option; since no such element exists it returned null on the
   product page and fell through to alert(). That branch was removed.) */
  function errorBox(){
    return document.getElementById('CartPageError');
  }

  function showCartError(msg){
    var box = errorBox();
    if(!box){ alert(msg); return; }
    box.textContent = msg;
    box.hidden = false;
    box.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }

  function clearCartError(){
    var box = document.getElementById('CartPageError');
    if(box){ box.hidden = true; box.textContent = ''; }
  }


  function changeQty(key, qty){
    return fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type':'application/json', 'Accept':'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(r){
      return r.json().then(function(data){
        if(!r.ok) throw new Error(data.description || data.message || window.cartStrings.error);
        return data;
      });
    })
    .then(function(cart){
      clearCartError();
      /* changeQty is only called from the [data-remove] button on the cart page, where a
   full reload is the right choice, because discounts, the shipping line and market
   logic are all recalculated server side. */
      window.location.reload();
      return cart;
    })
    .catch(function(err){ showCartError(err.message || window.cartStrings.error); });
  }

  document.addEventListener('click', function(e){
    var rm = e.target.closest('[data-remove]');
    if(!rm) return;
    /* Dugme type="submit" ve name="updates[<key>]" tasiyor: JS kapaliyken
       form /cart'a post edilip satir silinir, JS aciksa buradan AJAX gider. */
    e.preventDefault();
    changeQty(rm.getAttribute('data-remove'), 0);
  });

  // Add-to-cart forms
  document.addEventListener('submit', function(e){
    var form = e.target.closest('form[action*="/cart/add"]');
    if(!form) return;
    e.preventDefault();
    clearCartError();

    var btn = form.querySelector('[type=submit]');
    if(btn){ btn.classList.add('is-loading'); btn.setAttribute('aria-disabled','true'); }

    
    var _fd = new FormData(form);
    var _kalem = { id: _fd.get('id'),
                   quantity: parseInt(_fd.get('quantity') || '1', 10) || 1 };
    var _ozel = {};
    _fd.forEach(function(v, k){
      var m = k.match(/^properties\[(.+)\]$/);
      if (m) _ozel[m[1]] = v;
    });
    if (Object.keys(_ozel).length) _kalem.properties = _ozel;
    if (_fd.get('selling_plan')) _kalem.selling_plan = _fd.get('selling_plan');

    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type':'application/json', 'Accept':'application/json' },
      body: JSON.stringify({ items: [_kalem] })
    })
    .then(function(r){
      // Shopify answers 422 for sold-out / inventory conflicts; fetch does not reject on those.
      return r.json().then(function(data){
        if(!r.ok) throw new Error(data.description || data.message || window.cartStrings.error);
        return data;
      });
    })
    .then(function(){
      window.location.href = window.routes.cart_url;
    })
    .catch(function(err){ showCartError(err.message || window.cartStrings.error); })
    .finally(function(){
      if(btn){ btn.classList.remove('is-loading'); btn.removeAttribute('aria-disabled'); }
    });
  });
})();
